import { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";

const PaginationBarComp = ({ page, setPage, totalPages, perPage, setPerPage }) => {
  // تعداد صفحات قابل نمایش در وسط
  const visibleRange = 2;

  const startPage = Math.max(1, page - visibleRange);
  const endPage = Math.min(totalPages, page + visibleRange);

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
      {/* بخش سمت راست */}
      <div className="d-flex align-items-center gap-2">
        <span>نمایش در هر صفحه:</span>
        <Form.Select
          size="sm"
          value={perPage}
          style={{ width: "80px" }}
          onChange={(e) => {
            setPerPage(Number(e.target.value));
            setPage(1); // برگرد به صفحه اول
          }}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </Form.Select>
      </div>

      {/* بخش شماره صفحات */}
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <Button
          variant="outline-secondary"
          size="sm"
          disabled={page <= 1}
          onClick={() => setPage(page - 1)}
        >
          قبلی
        </Button>

        {startPage > 1 && (
          <>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setPage(1)}
            >
              1
            </Button>
            {startPage > 2 && <span>...</span>}
          </>
        )}

        {pages.map((p) => (
          <Button
            key={p}
            variant={p === page ? "secondary" : "outline-secondary"}
            size="sm"
            onClick={() => setPage(p)}
          >
            {p}
          </Button>
        ))}

        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span>...</span>}
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setPage(totalPages)}
            >
              {totalPages}
            </Button>
          </>
        )}

        <Button
          variant="outline-secondary"
          size="sm"
          disabled={page >= totalPages}
          onClick={() => setPage(page + 1)}
        >
          بعدی
        </Button>
      </div>

      {/* اطلاعات صفحه */}
      <div>
        صفحه <b>{page}</b> از <b>{totalPages}</b>
      </div>
    </div>
  );
};

export default PaginationBarComp;
